import Icon, { ICONS } from "../../general-ui/icon";
import classNames from 'classnames';
import { FILE_TYPES, SORT_METHODS } from "../../../store/utils/content-utils";
import { useDispatch, useSelector } from "react-redux";
import { checkAll, clearChecks, sortContent } from "../../../store/actions/admin/content-actions";
import { EventsState } from "../../../store/types";
import CustomCheckbox from "../../general-ui/checkbox/custom-checkbox";

interface HeaderArrowsProps {
	up: boolean;
	down: boolean;
}

export function HeaderArrows({ up, down }: HeaderArrowsProps): JSX.Element {
	return (
		<span className="header-arrows">
			<Icon name={ICONS.LITTLE_ARROW_UP} color={classNames({ on: up })} size={5} />
			<Icon name={ICONS.LITTLE_ARROW_DOWN} color={classNames({ on: down })} size={5} />
		</span>
	);
}

interface ListHeadersProps {
	idList: (number | string)[];
}

export default function ListHeaders({ idList }: ListHeadersProps): JSX.Element {
	const {
		ContentReducer: {
			fileType,
			sortBy,
			selectAll,
		},
	} = useSelector((state: EventsState) => state);
	const dispatch = useDispatch();
	const handleListCheck = (isChecked: boolean) => {
		if (isChecked) { dispatch(checkAll(idList)); }
		else { dispatch(clearChecks()); }
	};
	const handleNameSort = () => {
		if (sortBy === SORT_METHODS.AZ) { dispatch(sortContent(SORT_METHODS.ZA)); }
		else { dispatch(sortContent(SORT_METHODS.AZ)); }
	};
	const handleUploadedSort = () => {
		if (sortBy === SORT_METHODS.NEWEST) { dispatch(sortContent(SORT_METHODS.OLDEST)); }
		else { dispatch(sortContent(SORT_METHODS.NEWEST)); }
	};

	const handleDurationSort = () => {
		if (sortBy === SORT_METHODS.SHORTEST) { dispatch(sortContent(SORT_METHODS.LONGEST)); }
		else { dispatch(sortContent(SORT_METHODS.SHORTEST)); }
	};
	const handleSizeSort = () => {
		if (sortBy === SORT_METHODS.SMALLEST) { dispatch(sortContent(SORT_METHODS.LARGEST)); }
		else { dispatch(sortContent(SORT_METHODS.SMALLEST)); }
	};

	const getVariableHeader = () => {
		switch (fileType) {
			case (FILE_TYPES.UPLOADED):
			case (FILE_TYPES.RECORDED): return (<div onClick={handleDurationSort}>
				<span className={classNames("header", { on: isDuration })}>
					DURATION
				</span>
				<HeaderArrows up={sortBy === SORT_METHODS.SHORTEST} down={sortBy === SORT_METHODS.LONGEST} />
			</div>);
			case (FILE_TYPES.FONTS): return <br />;
			case (FILE_TYPES.PALETTES): return <br />;
			default: return (<div onClick={handleSizeSort}>
				<span className={classNames("header", { on: isSize })}>
					FILE SIZE
				</span>
				<HeaderArrows up={sortBy === SORT_METHODS.SMALLEST} down={sortBy === SORT_METHODS.LARGEST} />
			</div>);
		}
	};
	const isName = sortBy === SORT_METHODS.AZ || sortBy === SORT_METHODS.ZA;
	const isUploaded = sortBy === SORT_METHODS.NEWEST || sortBy === SORT_METHODS.OLDEST;
	const isDuration = sortBy === SORT_METHODS.SHORTEST || sortBy === SORT_METHODS.LONGEST;
	const isSize = sortBy === SORT_METHODS.SMALLEST || sortBy === SORT_METHODS.LARGEST;

	return (
		<li className="content-item list-item list-headers">
			<CustomCheckbox
				size={16}
				checked={selectAll}
				onChange={handleListCheck}
				name="List-Check-All"
				selectedIconName={ICONS.SQUARE_CHECKBOX_ALL}
				unselectedIconName={ICONS.SQUARE_CHECKBOX_UNSELECTED}
			/>
			<div onClick={handleNameSort}>
				<span className={classNames("header", { on: isName })}>NAME</span>
				<HeaderArrows up={sortBy === SORT_METHODS.AZ} down={sortBy === SORT_METHODS.ZA} />
			</div>
			{getVariableHeader()}
			<div onClick={handleUploadedSort}>
				<span className={classNames("header", { on: isUploaded })}>UPLOADED</span>
				<HeaderArrows up={sortBy === SORT_METHODS.NEWEST} down={sortBy === SORT_METHODS.OLDEST} />
			</div>
		</li>
	);
}